<template>
  <div>
    <v-card>
      <v-card-title>

      </v-card-title>

      <v-card-text>
        <v-autocomplete
          v-model="currentStudentSearch"
          :items="studentsResult"
          :loading="isLoading"
          :search-input.sync="searchStudent"
          color="primary"
          hide-no-data
          hide-selected
          item-text="full_name"
          item-value="id"
          placeholder="Buscar estudiante"
          return-object
        ></v-autocomplete>
        <div v-if="studentRestrictions[studentFound.id] && !studentRestrictions[studentFound.id].available">
          <v-alert
            :value="true"
            type="warning"
            outline
          >
            <ul>
              <li
                v-if="studentRestrictions[studentFound.id] && studentRestrictions[studentFound.id].grade"
              >
                {{ $t('extracurriculares.register.available_courses.grade_requirement') }}
              </li>

              <li
                v-if="studentRestrictions[studentFound.id] && studentRestrictions[studentFound.id].age"
              >
                {{ $t('extracurriculares.register.available_courses.age_requirement') }}
              </li>
              <li
                v-if="studentRestrictions[studentFound.id] && studentRestrictions[studentFound.id].prerequisite"
              >
                {{ $t('extracurriculares.register.available_courses.course_requirement') }}
              </li>
              <li
                v-if="shcedulesValidations[studentFound.id]"
              >
                {{ $t('extracurriculares.register.available_courses.schedule_requirement') }}
              </li>
            </ul>
          </v-alert>
        </div>
        <div v-if="available">
          <v-select
            :items="course_schedules"
            label="Horario"
            :v-errors="errors"
            v-model="form.schedule_id"
            name="schedule_id"
            v-validate="'required'"
            @change="validateSchedules"
            :disabled="studentRestrictions[studentFound.id] && !studentRestrictions[studentFound.id].available"
          ></v-select>

          <div v-if="shcedulesValidations[form.schedule_id]">
            <v-alert
              :value="true"
              type="warning"
              outline
            >
              <ul>
                <li
                  v-if="shcedulesValidations[form.schedule_id]"
                >
                  {{ $t('extracurriculares.register.available_courses.schedule_requirement') }}
                </li>
              </ul>
            </v-alert>
          </div>

          <select-input
              :form="form"
              :items="register_status"
              label="Estado reserva"
              :v-errors="errors"
              :value.sync="form.status"
              name="status"
              v-validate="'required'"
            ></select-input>

            <select-input
              v-if="form.status == 1"
              :form="form"
              :items="students_status"
              label="Estado matricula"
              :v-errors="errors"
              :value.sync="form.student_status"
              name="student_status"
              v-validate="'required'"
            ></select-input>

            <select-input
              v-if="form.status == 1"
              :form="form"
              :items="student_last_payments"
              label="Relacionar pago"
              :v-errors="errors"
              :value.sync="form.payment_to_asociate"
              name="payment_to_asociate"
              v-validate="'required'"
            ></select-input>

          <v-textarea
            outline
            label="Motivo"
            name="reason"
            v-model="form.reason"
            v-validate.disable="'required'"
            data-vv-name="reason"
            :error-messages="errors.collect('reason')"
          ></v-textarea>

        </div>
      </v-card-text>


      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="$emit('closeModal')">Cancelar</v-btn>
          <v-btn
                :disabled="studentRestrictions[studentFound.id] && !studentRestrictions[studentFound.id].available || shcedulesValidations[form.schedule_id]"
                color="blue darken-1"
                flat
                @click="registerStudent">Registrar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import Form from 'vform'
  export default {
    name: 'admin-extra-register',
    props: {
      course: {
        type: Object,
        required: true
      },
      registration_id: {
        type: Number,
      },
      modal_open: {
        type: Boolean
      }
    },
    watch: {
      course(newValue, oldValue) {
        this.init()
        if (newValue) {
          this.course_schedules = []
          newValue
            .active_schedules.forEach(schedule => {
            this.course_schedules.push({ value: schedule.id, text: schedule.name })
          })
        }
      },
      searchStudent(val) {
      if (!val) return
      if (this.isLoading) return

      this.isLoading = true
      this.available = false
      this.studentRestrictions = {}
      this.shcedulesValidations = {}
      axios.get(`/api/extracurriculares/admin/enrollment/search_student/${val}`)
        .then(res => {
          const { data } = res
          let available = false
          const course = this.$props.course
          this.entries = data.filter(student => {
            available = false
            if (course.exclusion_type === 'grade' && course.grades) {
              available = course.grades
                .split(', ')
                .includes(student.grade_level)
            } else if (course.exclusion_type === 'next_grade' && course.grades) {
              available = course.grades
                .split(', ')
                .includes(student.next_grade)
            } else if (course.ages) {
              const ages = course.ages
                .split(' - ')
                .map(age => parseInt(age, 10))
                available = student.age >= ages[0] && student.age <= ages[1]
            } else {
              available = true
            }

            return available
          })
        })
        .catch(err => {
        })
        .finally(() => (this.isLoading = false))
      },
      currentStudentSearch: function(newVal, oldval) {
        if (newVal) {
          this.isLoading = true
          axios.get(`/api/extracurriculares/admin/enrollment/student/${newVal.id}`)
          .then(res => {
            const { data } = res
            this.studentFound = data.student
            this.student_last_payments = [{ value: 0, text: 'Pago externo' }].concat(
              data.last_payments.map(payment => {
                return {
                  value: payment.payment_id,
                  text: `${payment.course.name} - $ ${payment.payment.platform_payment_total}`
                }
              })
            )
            this.isLoading = false
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
        }
      },
      studentFound: function(newVal, oldVal) {
        if (newVal.id) {
          this.validateCourseRequirements()
        }
      },
      modal_open: function(newVal, oldVal) {
        if (newVal) {
          this.init()
        }
      }
    },
    data() {
      return {
        student_last_payments: [],
        course_schedules: [],
        entries: [],
        currentStudentSearch: null,
        searchStudent: null,
        studentNameMaxLength: 80,
        isLoading: false,
        studentFound: {},
        available: false,
        shcedulesValidations: {},
        studentRestrictions: {},
        register_status: [
          { value: 0, text: 'Pendiente' },
          { value: 1, text: 'Pagado' },
        ],
        students_status: [
          { value: 'ENROLLED', text: 'Matriculado' },
          { value: 'APPROVED', text: 'Curso aprobado' },
        ],
        form: new Form({
          course_id: '',
          student_id: '',
          family_id: '',
          schedule_id: '',
          status: '',
          student_status: '',
          reason: '',
          course_register_dates_id: '',
          payment_to_asociate: '',
          siesa_sucursal: '',
        })
      }
    },
    computed: {
      studentsResult() {
        return this.entries.map(student => {
          student.full_name.length > this.studentNameMaxLength
            ? student.full_name.slice(0, this.studentNameMaxLength) + '...'
            : student.full_name

          return Object.assign({}, student)
        })
      }
    },
    methods: {
      validateCourseRequirements() {
        this.studentRestrictions = {}
        const course_id = this.$props.course.id
        const course = this.$props.course
        const student = this.studentFound
        let available = true;
        let grade = false;
        let age = false;
        let prerequisite = false

        if (course.exclusion_type === 'grade' && course.grades) {
          available = course.grades
            .split(', ')
            .includes(student.grade_level)
            grade = !available
        }

        if (course.exclusion_type === 'next_grade' && course.grades) {
          available = course.grades
            .split(', ')
            .includes(student.next_grade)
            grade = !available
        }

        if (course.exclusion_type === 'age' && course.ages) {
          const ages = course.ages
            .split(' - ')
            .map(age => parseInt(age, 10))
          available = student.age >= ages[0] && student.age <= ages[1]
          age = !available
        }

        if (course.prerequisite_id) {
          const prerequisite_approved = student.approved_courses &&
            student.approved_courses.filter(course => course.course_id === course.prerequisite_id).length > 0

          available = prerequisite_approved
          prerequisite = !prerequisite_approved
        }
        this.available = available
        this.studentRestrictions[student.id] = {
          available,
          grade,
          age,
          prerequisite
        }
      },
      validateSchedules() {
        this.shcedulesValidations = {};
        const schedule_id = this.form.schedule_id
        const course_id = this.$props.course.id
        const course = this.$props.course
        const student = this.studentFound
        const schedule_to_validate_details = course
          .active_schedules
          .find(schedule => schedule.id === schedule_id)
          .details

        if (!course.no_validation) {
          student
          .active_reservations
          .forEach(reservation => {
            reservation.schedule.details
              .forEach(reservation_detail => {
              schedule_to_validate_details.filter(schedule_to_validate => schedule_to_validate.day === reservation_detail.day)
                .forEach(validation_detail => {
                  if (
                      ((Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) >= Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) &&
                        Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) <= Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`))
                      ||
                      (Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) >= Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) &&
                        Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) <= Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`)))
                      ||
                      (Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) >= Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) &&
                        Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) <= Date.parse(`1990-01-01 ${validation_detail.time_to}:00`))
                      ||
                      (Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`) >= Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) &&
                        Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`) <= Date.parse(`1990-01-01 ${validation_detail.time_to}:00`))
                    ) {
                      this.shcedulesValidations[validation_detail.schedule_id] = true
                    }
                })
            })
          });
        }
      },
      registerStudent() {
        this.form.course_id = this.$props.course.id
        this.form.student_id = this.studentFound.id
        this.form.family_id = this.studentFound.family_id
        this.form.siesa_sucursal = this.studentFound.siesa_sucursal
        this.form.course_register_dates_id = this.$props.registration_id
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.form.post('/api/extracurriculares/admin/enrollment/new')
              .then(resp => {
                if (resp.status === 200) {
                  if (resp.data.portfolio) {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        title: 'Reserva no realizada',
                        text: 'El estudiante se encuentra en cartera',
                        modal: true
                    })
                    return
                  }
                  this.$emit('updateDetail')
                  this.init()
                  this.$emit('closeModal')
                  this.$store.dispatch('responseMessage', {
                      type: 'success',
                      text: 'Reserva realizada correctamente',
                      modal: false
                  })
                }
              })
              .catch(error => console.log(error))
          }
        })
      },
      init() {
        this.available = false
        this.studentRestrictions = {}
        this.shcedulesValidations = {}
        this.currentStudentSearch = null
        this.searchStudent = null
        this.entries = []
        this.studentFound = {}
        this.form = new Form({
          course_id: '',
          student_id: '',
          family_id: '',
          schedule_id: '',
          status: '',
          student_status: '',
          reason: '',
          course_register_dates_id: ''
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/admin/enrollment_register.vue